// models/storageModel.js
export const setWithExpiry = (key, value, ttl = 30 * 24 * 60 * 60 * 1000) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  try {
    localStorage.setItem(key, JSON.stringify(item));
  } catch (e) {
    console.error("Error saving to localStorage:", e);
  }
};

export const getWithExpiry = (key) => {
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (e) {
    console.error("Error parsing localStorage item:", e);
    localStorage.removeItem(key); // Удаляем поврежденные данные
    return null;
  }
};